import RetireSpokePage from "@/components/retire-spoke/RetireSpokePage";

const RetireAt55 = () => <RetireSpokePage age={55} />;

export default RetireAt55;
